
export const getRangeValueAsArray = (rangeValues) => {
    const newValues = [];
    let trimmedRangeValue;
    //inbound and outbound rangeValues have different delimiters to split by
    if (rangeValues) {
        const rValue = typeof(rangeValues) === "object" ? rangeValues.CODES : rangeValues;

        // Replace + with space in rValue
        const sanitizedRValue = rValue.replace(/\+/g, ' ');

        if (sanitizedRValue?.includes("%1E")) {
            trimmedRangeValue = sanitizedRValue?.substr(0, sanitizedRValue.length - 3)?.split('%1E');
        } else if (sanitizedRValue?.includes("\u001e")) {
            trimmedRangeValue = sanitizedRValue.split("\u001e");
            trimmedRangeValue = trimmedRangeValue.filter(str => str !== "");
        }
    } 

    if (trimmedRangeValue?.length > 1) {
        for (let i = 0; i < trimmedRangeValue.length; i++) {
            let keyValuePairs;
            if (trimmedRangeValue[i].includes('%1F')) keyValuePairs = trimmedRangeValue[i]?.split('%1F');
            if (trimmedRangeValue[i].includes('\u001f')) keyValuePairs = trimmedRangeValue[i]?.split('\u001f');
            const pair = {
                VALUE: keyValuePairs[0],
                DESCRIPTION: keyValuePairs[1],
                ID: i
            }
            newValues.push(pair);
        }
    } else {
        let keyValuePair;
        if (trimmedRangeValue && trimmedRangeValue[0]?.includes('%1F')) keyValuePair = trimmedRangeValue[0].split('%1F');
        else if (trimmedRangeValue && trimmedRangeValue[0]?.includes('\u001f')) keyValuePair = trimmedRangeValue[0].split('\u001f');
        else  keyValuePair = [trimmedRangeValue[0] || '', ''];
        newValues?.push({ VALUE: keyValuePair[0], DESCRIPTION: keyValuePair[1], ID: 0});
    }
    return newValues;
}

export const getRangeValueAsString = (rangeValues) => {
    let newRangeValue = '';
    if (rangeValues?.length > 1) {
        const arr = [];
        for (let i = 0; i < rangeValues.length; i++) {
            let temp = '';
            let des = rangeValues[i].DESCRIPTION !== '' ? rangeValues[i].DESCRIPTION : '';
            temp = [rangeValues[i].VALUE, des]?.join('%1F')
            arr.push(temp);
        }
        newRangeValue = arr?.join('%1E')?.concat('%1E');
    } else {
        const res = [rangeValues[0].VALUE, rangeValues[0].DESCRIPTION]?.join('%1F');
        newRangeValue = res?.concat('%1E');
    }
    return newRangeValue;
}